<template>
  <div v-if="PreviewShow" class="overlay" @click.self="close">
    <div class="overlay-content">
      <button @click="close" class="close-button">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <div v-if="isLoading" class="loading"><img src="/static/img/waitingNew.svg" alt="Loading..." class="loading-image" /></div>
      <div v-else class="scrollable-content" v-html="htmlContent"></div>
      <div class="download-btn">
        <button @click="downloadPdf">Download PDF</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getShowPdf } from '@/request/order.js'
export default {
  name: 'OrderPdf',
  props: ['visible', 'type'],
  data () {
    return {
      isLoading: true,
      PreviewShow: false,
      htmlContent: ''
    }
  },
  watch: {
    visible: function (data) {
      this.PreviewShow = data
      if (data) {
        this.ShowPdf()
      }
    }
  },
  methods: {
    close () {
      this.htmlContent = ''
      this.$emit('updateVisible', false)
    },
    ShowPdf () {
      let orderno = this.$route.query.orderno
      if (orderno === undefined) {
        this.close()
        return false
      }
      this.isLoading = true
      let time = parseInt(new Date().getTime() / 1000)
      // 验证verify
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      let sessionid = this.common.sessionidGet(this)
      let dataJson = {
        'orderno': orderno,
        'time': time,
        'currency': this.common.currencySet(this),
        'language': this.common.languageSet(this),
        'token': token,
        'sessionid': sessionid,
        'type': this.type,
        'operation': 'getShowPdfInfo'
      }
      let data = this.common.encryptionData(dataJson, this)
      getShowPdf(data).then(res => {
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '101') {
          alert(res.msg)
        } else if (res.flag === '200') {
          this.htmlContent = res.data
          this.isLoading = false
        }
      })
    },
    async downloadPdf () {
      let orderno = this.$route.query.orderno
      if (orderno === undefined) {
        this.close()
        return false
      }
      let time = parseInt(new Date().getTime() / 1000)
      // 验证verify
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      let sessionid = this.common.sessionidGet(this)
      let dataJson = {
        'orderno': orderno,
        'time': time,
        'currency': this.common.currencySet(this),
        'language': this.common.languageSet(this),
        'token': token,
        'sessionid': sessionid,
        'type': this.type,
        'operation': 'downloadPdf'
      }
      let data = this.common.encryptionData(dataJson, this)
      let fileUrl = '/api/getTripDetail?' + new URLSearchParams(data).toString()
      let response = await fetch(fileUrl)
      let blob = await response.blob()
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.type + '_' + orderno + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>

<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* 防止后面内容滚动 */
}

.overlay-content {
  position: relative; /* 设置为相对定位 */
  background: white;
  padding: 20px 20px 10px;
  border-radius: 5px;
  max-width: 800px;
  width: 100%;
  height: 80%; /* 限制最大高度 */
  overflow-y: auto; /* 允许内容垂直滚动 */
}

.scrollable-content {
  height: calc(80vh - 50px); /* 适应视口高度，留出空间给下载按钮 */
  overflow-y: auto; /* 内容滚动 */
}

.close-button {
  z-index: 9999;
  position: absolute; /* 绝对定位 */
  top: 10px; /* 距离顶部 */
  right: 10px; /* 距离右侧 */
  background: none; /* 去掉默认背景 */
  border: none; /* 去掉默认边框 */
  cursor: pointer; /* 鼠标指针样式 */
}

.close-button i {
  color: #5366a3;
  font-weight: 650;
}

.close-button i:before {
  content: "\E6DB";
}

.download-btn {
  width: 100%;
  text-align: center;
  margin-top:5px;
}

.download-btn button {
  width: 220px;
  padding: 12px;
  background-color: #2470fd;
  color: white;
  text-align: center;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.3s;
  box-shadow: 0 2px 5px rgba(36,112,253,0.3);
}

.download-btn button:hover {
  background-color: #1a5fd9;
}

.loading {
  height: calc(80vh - 50px); /* 适应视口高度，留出空间给下载按钮 */
  text-align: center; /* 居中对齐 */
  font-size: 18px; /* 字体大小 */
  color: #333; /* 字体颜色 */
}

.loading-image {
  margin-top: 25%;
  height: 40%;
  width: 100%;
  left: 0
}
</style>



// WEBPACK FOOTER //
// src/components/account/module/OrderPdf.vue